import { render, staticRenderFns } from "./WorkProcess.vue?vue&type=template&id=edde75a8&"
import script from "./WorkProcess.vue?vue&type=script&lang=js&"
export * from "./WorkProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports